import {Component, OnInit} from '@angular/core';
import {Constants} from '../Services/Constants';
import {HTTPService} from '../Services/http.service';
import {Observable}   from 'rxjs/Observable';
import {filter} from '../App/search.pipe';
import {MySharedService} from '../App/shared.service';

//import {DataTableDirectives} from 'angular2-datatable/datatable';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any,Columns?: any): void;

@Component({
    templateUrl: './AppViews/ResourceGrade/ResourceGradeAndCost.html' 
})

export class ResourceGradeAndCostComponent implements OnInit {

    public constants: Constants;
    userDetail: any;
    loadResourceCost:number=1;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
            this.constants = new Constants();
            this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() {
     
    }

    loadTab(val){
        console.log(val);
        this.loadResourceCost=val;
    }

}
        


/** WEBPACK FOOTER **
 ** ./TypeScripts/ResourceGrade/ResourceGradeAndCost.component.ts
 **/